// extracted by mini-css-extract-plugin
export default {"root":"IconCard_root__qOWdi"};